import FooterHeader from "./FooterHeader";
import FooterMain from "./FooterMain";
import FooterCopyright from "./FooterCopyright";
import * as styles from "./styles.module.scss";
import EmitationBox from "./EmitationBox";

export function Footer({
  logo,
  description,
  location_info,
  numbers_info,
  contact_info,
  main_menu,
  group_menu,
  copyrights_menu,
  copyrights_title,
}: FooterTemplate) {
  return (
    <footer className={styles.footer}>
      <EmitationBox />
      <div className="container">
        <FooterHeader logo={logo} description={description} />
      </div>
      <span className={styles.separator} />
      <div className="container">
        <FooterMain
          location_info={location_info}
          numbers_info={numbers_info}
          contact_info={contact_info}
          main_menu={main_menu}
          group_menu={group_menu}
          copyrights_menu={copyrights_menu}
        />
      </div>
      <span className={styles.separator} />
      <div className="container">
        <FooterCopyright
          copyrights_title={copyrights_title}
          copyrights_menu={copyrights_menu}
        />
      </div>
    </footer>
  );
}
